document.addEventListener('DOMContentLoaded', function () {
  var swiper = new Swiper('.swiper-container', {
    centeredSlides: true,
    slidesPerView: 'auto',
    spaceBetween: 12,
    loop: true,
    allowTouchMove: true,
    simulateTouch: true,
    grabCursor: true,
    initialSlide: Math.floor(document.querySelectorAll('.swiper-slide').length / 2),
    navigation: {
      nextEl: '.swiper-button-next-custom',
      prevEl: '.swiper-button-prev-custom',
    },
    mousewheel: {
      enabled: true,
      forceToAxis: true,
    },
    breakpoints: {
      769: {
        spaceBetween: 16,
        centeredSlides: true,
        slidesPerView: 'auto',
      },
    },
  });

  window.playVideo = function (videoCard, event) {
    let videoElement = videoCard.querySelector('.inline-video');
    
    // If video is already playing and visible, don't interfere (let controls work)
    if (videoElement && !videoElement.paused) {
      return;
    }

    // Pause all other videos first
    const allVideos = document.querySelectorAll('.inline-video');
    allVideos.forEach(function(video) {
      if (video !== videoElement) {
        video.pause();
      }
    });
    
    if (!videoElement) {
      const videoUrl = videoCard.getAttribute('data-video-url');
      
      if (!videoUrl) {
        return;
      }
      
      videoElement = document.createElement('video');
      videoElement.className = 'inline-video';
      videoElement.muted = true;
      videoElement.loop = true;
      videoElement.controls = true;
      videoElement.playsInline = true;
      videoElement.webkitPlaysInline = true;
      videoElement.setAttribute('preload', 'auto');
      videoElement.setAttribute('controlsList', 'nodownload noremoteplayback');
      videoElement.setAttribute('disablePictureInPicture', true);

      const sourceElement = document.createElement('source');
      sourceElement.src = videoUrl;
      
      if (videoUrl.includes('.m3u8')) {
        sourceElement.type = 'application/x-mpegURL';
      } else {
        sourceElement.type = videoUrl.includes('.mp4') ? 'video/mp4' : 'video/*';
      }
      
      videoElement.appendChild(sourceElement);
      videoCard.insertBefore(videoElement, videoCard.firstChild);
    }

    // Stop clicks on video from bubbling to video-card (for both new and existing videos)
    if (!videoElement.hasClickListener) {
      videoElement.addEventListener('click', function(e) {
        e.stopPropagation();
      });
      videoElement.hasClickListener = true;
    }

    const posterOverlay = videoCard.querySelector('.poster-overlay');
    if (posterOverlay) {
      posterOverlay.style.display = 'none';
      posterOverlay.style.pointerEvents = 'none';
    }

    videoElement.controls = true;
    videoElement.style.pointerEvents = 'auto';
    
    // Disable the video-card click once video is playing
    videoCard.style.pointerEvents = 'none';
    videoElement.style.pointerEvents = 'auto';
    
    videoElement.play().catch((e) => console.error('Video play error:', e));
  };
});
